import log from 'salvo-lite/log'

class NativeAppPrompt {
    constructor (theme, elem) {
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        let deferredPrompt
        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault()
            // Stash the event so it can be triggered later.
            deferredPrompt = e

            deferredPrompt.prompt()

            // Wait for the user to respond to the prompt
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt')
                } else {
                    console.log('User dismissed the A2HS prompt')
                }
                deferredPrompt = null
            })
        })
    }
}

export default NativeAppPrompt



// WEBPACK FOOTER //
// ./src/resources/scripts/components/NativeAppPrompt.js